import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { connectSocket } from "../lib/socket";
import { playNotificationSound, unlockNotificationSound } from "../lib/notificationSound";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export async function registerPushSubscription() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
  const vapidKey = process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY;
  const registration = await navigator.serviceWorker.register("/nexora-sw.js");
  if (!vapidKey || Notification.permission !== "granted") return;
  const existing = await registration.pushManager.getSubscription();
  const subscription =
    existing ||
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    }));
  await api.post("/push/subscribe", subscription.toJSON());
}

export default function NotificationBridge() {
  useEffect(() => {
    let cleanup = null;
    registerPushSubscription().catch(() => {});

    if ("Notification" in window && Notification.permission === "default") {
      toast("Notifications Nexora", {
        description: "Activez les alertes avec son pour les courses, paiements, messages et validations.",
        action: {
          label: "Activer",
          onClick: async () => {
            await unlockNotificationSound();
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
              await registerPushSubscription().catch(() => {});
              toast.success("Notifications activees");
              playNotificationSound();
            }
          },
        },
        duration: 12000,
      });
    }

    (async () => {
      const socket = await connectSocket();
      if (!socket) return;
      socket.connect();
      const onNotification = (notification) => {
        const urgent = ["sos", "ride", "payment"].some((key) => String(notification?.data?.target || notification?.data?.type || "").includes(key));
        playNotificationSound(urgent ? "urgent" : "message");
        toast(notification.title || "NEXORA-CAB", {
          description: notification.body,
          icon: "N",
          duration: 8000,
        });
        if ("Notification" in window && Notification.permission === "granted") {
          new Notification(notification.title || "NEXORA-CAB", {
            body: notification.body,
            data: notification.data || {},
            icon: "/icon-192.png",
            badge: "/icon-192.png",
            tag: notification?.data?.ride_id || notification?.id || "nexora",
            renotify: true,
            silent: false,
          });
        }
      };
      socket.on("notification.new", onNotification);
      cleanup = () => socket.off("notification.new", onNotification);
    })();

    return () => {
      if (cleanup) cleanup();
    };
  }, []);

  return null;
}
